import BaseModel from "../models/BaseModel";
import BaseModelMap from "../models/BaseModelMap";
import ObjectSet from "../models/ObjectSet";
import TreeViewModel from "../models/TreeviewModel";

export default class ObjectSetsTreeviewModel extends TreeViewModel {
  constructor(obj: BaseModel) {
    super(obj);
  }

  get typedObj(): BaseModelMap<ObjectSet> {
    return this.obj as BaseModelMap<ObjectSet>;
  }

  // get isSelectable(): boolean {
  //   return false;
  // }

  get isFolder(): boolean {
    return true;
  }

  getTagNeeded(): boolean {
    return false;
  }

  getDisableEdit(): boolean {
    return true;
  }

  get childCollection(): Array<BaseModel> | undefined {
    return state.objectSets.sortBy("tag");
  }

  handleDelete(): void {
    this.typedObj.items.forEach((objectSet) => {
      objectSet.delete();
    });
    this.typedObj.clear();
  }

  getButtons(): JSX.Element[] | undefined {
    return [super.inlineButton_Delete()];
  }
}
